import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { imageUrl } from '../lib/catalog';
import { BlurFade } from './magicui/blur-fade';

const collectionImages = {
  indoor: '/api/catalog-media/94cc1889f4e5dcb72ff1aab1a236ac59',
  garden: '/api/catalog-media/5bb51579b05a53c20cc809e59fc9389c',
  magnetic: '/api/catalog-media/4a9899238fb144a552d33a81e29e7758',
  tech: '/api/catalog-media/2503666f17ed21678fcdfbbb998625e8',
};

export const HomeCollections = ({ collections }) => <section className="premium-section" data-testid="home-collections">
  <div className="premium-container">
    <div className="premium-section-heading"><div><p className="premium-eyebrow">Od interijera do eksterijera</p><h2 data-testid="home-collections-title">Četiri kolekcije. Vaš prostor.</h2></div><Link to="/webshop" className="premium-text-link" data-testid="home-all-collections">Sva rasvjeta <ArrowUpRight size={16} /></Link></div>
    <div className="premium-collection-grid">
      {collections.map((c, i) => <BlurFade key={c.id} delay={i * 0.04}>
        <Link to={`/webshop?collection=${c.id}`} className="premium-collection" data-testid={`home-collection-${c.id}`}>
          <div className="premium-collection-image"><img src={imageUrl(collectionImages[c.id])} alt={`MAXLIGHT ${c.name}`} loading="lazy" data-testid={`home-collection-image-${c.id}`} /></div>
          <div className="premium-collection-info"><div><h3 data-testid={`home-collection-name-${c.id}`}>{c.name}</h3>{c.count != null && <small data-testid={`home-collection-count-${c.id}`}>{c.count} proizvoda</small>}</div><ArrowUpRight size={20} aria-hidden="true" /></div>
        </Link>
      </BlurFade>)}
    </div>
  </div>
</section>;